module.exports = __webpack_public_path__ + "img/icon_route (1).3ea44aba.svg";